/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import "@rmwc/grid/styles";
import Direction from "../../../commons/Direction";
import { Grid as MdGrid } from "@rmwc/grid";

export type GridProps = {
  dir?: Direction;
  align?: "right" | "left";
  fixedColumnWidth?: boolean;
  className?: string;
};

const Grid: FC<GridProps> = ({ children, dir = Direction.RTL, align, className, fixedColumnWidth }) => {
  return (
    <MdGrid css={css``} dir={dir} align={align} fixedColumnWidth={fixedColumnWidth} className={className}>
      {children}
    </MdGrid>
  );
};

export default Grid;
